import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// Components
import { PdpSharedIconBubblePinterest } from '../PdpSharedIconBubbles/PdpSharedIconBubblePinterest';
import { PdpSharedIconBubbleFacebook } from '../PdpSharedIconBubbles/PdpSharedIconBubbleFacebook';
import { PdpSharedIconBubbleEmail } from '../PdpSharedIconBubbles/PdpSharedIconBubbleEmail';
import { PdpRespIconBubblePrint } from './PdpRespIconBubblePrint';

function PdpRespIconBubblesComponent(props) {
    const { item, skuId, user, viewer } = props;

    return (
        <React.Fragment>
            {viewer.isPinterestShareEnabled && <PdpSharedIconBubblePinterest item={item} />}
            {viewer.isFacebookShareEnabled && <PdpSharedIconBubbleFacebook item={item} />}
            <PdpSharedIconBubbleEmail item={item} user={user} viewer={viewer} skuId={skuId} />
            <PdpRespIconBubblePrint />
        </React.Fragment>
    );
}

PdpRespIconBubblesComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
    skuId: PropTypes.string,
};

export const PdpRespIconBubbles = createFragmentContainer(PdpRespIconBubblesComponent, {
    viewer: graphql`
        fragment PdpRespIconBubbles_viewer on Viewer {
            ...PdpSharedIconBubbleEmail_viewer
            ... @include(if: $fetchPdp) {
                isPinterestShareEnabled: isEnabledByLocale(featureName: "PINTEREST_SHARE")
                isFacebookShareEnabled: isEnabledByLocale(featureName: "FACEBOOK_SHARE")
            }
        }
    `,
    item: graphql`
        fragment PdpRespIconBubbles_item on Item {
            ...PdpSharedIconBubblePinterest_item
            ...PdpSharedIconBubbleFacebook_item
            ...PdpSharedIconBubbleEmail_item
        }
    `,
    user: graphql`
        fragment PdpRespIconBubbles_user on User {
            ...PdpSharedIconBubbleEmail_user
        }
    `,
});
